<template>
  <Teleport to="body">

      <div v-if="modalIn" class="modal-container">
        <div class="modal-backdrop opacity-50"></div>

        <div class="modal show d-block" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog modal-dialog-scrollable" :class="computedModalClass">
            <div class="modal-content">
              <div class="modal-header bg-primary-subtle">
                <h5 class="modal-title" id="staticBackdropLabel"><slot name="header"></slot></h5>
                <button type="button" class="btn-close" @click="closeModal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <slot />
              </div>
              <div class="modal-footer d-none">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary">Understood</button>
              </div>
            </div>
          </div>
        </div>
      </div>

  </Teleport>
</template>

<script setup>
import { defineProps, defineEmits, watch, ref, computed, onMounted, onUnmounted } from "vue"

const props = defineProps({
  modalIn: { type: Boolean },
  modalClass: {
    type: String,
    default: "modal-fullscreen"
  },
  dynamic: {
    type: Boolean,
    default: false
  },
  breakpoint: {
    type: Number,
    default: 992 // lg breakpoint
  }
})

//const propRef = toRef(props, 'modalIn')
const emits = defineEmits(["close"])
const windowWidth = ref(window.innerWidth)

// Compute modal class based on dynamic prop
const computedModalClass = computed(() => {
  if (!props.dynamic) {
    return props.modalClass
  }

  // Dynamic: use fullscreen on mobile, modalClass on desktop
  return windowWidth.value < props.breakpoint ? 'modal-fullscreen' : props.modalClass
})

function handleResize() {
  windowWidth.value = window.innerWidth
}

onMounted(() => {
  if (props.dynamic) {
    window.addEventListener('resize', handleResize)
  }
})

onUnmounted(() => {
  if (props.dynamic) {
    window.removeEventListener('resize', handleResize)
  }
})

watch(() => props.modalIn, (newValue) => {
  if (newValue) {
    document.body.classList.add("modal-open")
  } else {
    document.body.classList.remove("modal-open")
  }
})

function closeModal() {
  document.body.classList.remove("position-fixed");
  emits('close')
}
</script>

<style lang="scss" scoped>
.modal-container {
  position:fixed;
  width: 100vw;
  height: 100vh;
  top:0;
  left:0;
  z-index: 1050;
}
.modal-backdrop {
  position:absolute;
  width: 100vw;
  height: 100vh;
  top:0;
  left:0;
  z-index: 1050;
}
</style>
